import React, { Component } from 'react';
import "./footer.css";
export default class MobileFooter extends Component {

    render() {
        return (
            <footer className="container">
                <div className="col footerbox">
                    <div className="row">
                        <div className="col">
                            <h2>فـــردا به نـــوآوری نیــازمــند است</h2>
                            <p>هوایار پلاس یک اپلیکیشن تحت وب برای کاربران مجموعه هوایار جهت دسترسی آسانتر به خدمات و استعلام و همچنین سایزینگ  محصولات می باشد.</p>
                        </div>
                    </div>
                    <div className="row">
                        <ul className="footerlink">
                            <li><a href="/about">هوایار</a></li>
                            <li><a href="/serviceRequest">خدمات پس از فروش</a></li>
                            <li><a href="/aboutApp">درباره اپلیکیشن</a></li>
                            <li><a target="_blank" href="../assets/pdf/AppUserManual.pdf" download>راهنمای اپلیکیشن</a></li>
                            <li><a href="/news">اخبار</a></li>
                        </ul>
                    </div>
                    <div className="row">
                        <div className="mr-t-30 align-c txt-white copyright">
                            تلفن : ۴۱۹۷۶(۰۲۱)
                        </div>
                        <div className="mr-t-5 align-c txt-white copyright">
                            ایمیل : info@havayar.com
                        </div>
                        <p className="mr-t-30 align-c txt-white copyright"><a href="/#">کلیه حقوق برای هوایار محفوظ است</a><i className="far fa-copyright"></i><span className="copyright-year">۱۴۰۱</span></p>
                    </div>
                </div>
            </footer>
        );
    }
}

